import L from "leaflet";
import { Marker } from "react-leaflet";
import { Bomstasjon } from "../../../services/RuteplanAPI";
import bomstasjonIconResource from "../../../assets/tollbooth.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const bomstasjonIcon = L.icon({
    iconUrl: bomstasjonIconResource,
    iconRetinaUrl: bomstasjonIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IBomstasjonMarkersProps {
    bomstasjoner: Array<Bomstasjon>;
}

export default function BomstasjonMarkers (props: IBomstasjonMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { bomstasjoner } = props;

    return (
        <>
            {bomstasjoner.map((bomstasjon: Bomstasjon, index: number) => {
                return (
                    <Marker key={bomstasjon.navn + index} 
                    position={[bomstasjon.location!.y, bomstasjon.location!.x]} 
                    icon={bomstasjonIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(bomstasjon);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}